import { connect } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'
import ContactFilterBuilder from 'components/ContactFilterBuilder'
import {
  addNewFilter,
  addNewGroup,
  applyFilter,
  changeSegment,
  changeView,
  closeFilterBuilder,
  editFilterProperty,
  editFilterValue,
  receiveContactProperties,
  receiveEventProperties,
  receivePlaybookEvents,
  receivePlaybooks,
  receiveTags,
  returnToPreviousView,
  saveSegment,
  setPlaybook,
} from 'modules/filter_builder/actions'

const mapStateToProps = state => ({
  orgId: state.user.orgId,
  view: state.__CRM.filterBuilder.view,
  playbook: state.__CRM.filterBuilder.playbook,
  groupIndex: state.__CRM.filterBuilder.groupIndex,
  filterIndex: state.__CRM.filterBuilder.filterIndex,
  defaultSegment: state.__CRM.filterBuilder.defaultSegment,
  currentSegment: state.__CRM.filterBuilder.segment,
  contactProperties: state.__CRM.filterBuilder.contact,
  eventProperties: state.__CRM.filterBuilder.events,
  tagProperties: state.__CRM.filterBuilder.tags,
  playbookEventProperties: state.__CRM.filterBuilder.playbookEvents,
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onReceiveContactProperties: properties => {
      dispatch(receiveContactProperties(properties))
    },
    onReceiveEventProperties: properties => {
      dispatch(receiveEventProperties(properties))
    },
    onReceivePlaybooks: playbooks => {
      dispatch(receivePlaybooks(playbooks))
    },
    onReceiveTags: tags => {
      dispatch(receiveTags(tags))
    },
    onReceivePlaybookEvents: events => {
      dispatch(receivePlaybookEvents(events))
    },
    onAddNewFilter: groupIndex => {
      dispatch(addNewFilter(groupIndex))
    },
    onAddNewGroup: () => {
      dispatch(addNewGroup())
    },
    onEditFilterProperty: ({
      groupIndex,
      filterIndex
    }) => {
      dispatch(editFilterProperty({
        groupIndex,
        filterIndex
      }))
    },
    onEditFilterValue: ({
      groupIndex,
      filterIndex
    }) => {
      dispatch(editFilterValue({
        groupIndex,
        filterIndex
      }))
    },
    onApplyFilter: () => {
      dispatch(applyFilter())
    },
    onChangeView: view => {
      dispatch(changeView(view))
    },
    onChangePlaybook: playbook => {
      dispatch(setPlaybook(playbook))
    },
    onChangeSegment: segment => {
      dispatch(changeSegment(segment))
    },
    onSaveSegment: property => {
      dispatch(saveSegment(property))
    },
    onCloseFilterBuilder: () => {
      dispatch(closeFilterBuilder())
    },
    onReturnToPreviousView: () => {
      dispatch(returnToPreviousView())
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactFilterBuilder)
